import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3001",
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem("p_u_t");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    if (error?.response?.status === 503 && error?.response?.data?.code === "MAINTENANCE_MODE") {
      window.dispatchEvent(new Event("maintenance-mode"));
    }
    if (error !== null && error?.response?.status === 401) {
      window.localStorage.removeItem("p_u_t");
      delete axiosInstance.defaults.headers.common.Authorization;
      window.localStorage.removeItem("userInfo");
      window.location.reload();
    }

    return Promise.reject(error || "Something went wrong!");
  },
);

export default axiosInstance;
